import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  // создание рейтинга
  createSiteRating(data) {
    return axios.post(`${i18n.locale}/api/public/siteRating/createSiteRating`, data)
  },
  // данные о среднем рейтинге
  getAverageRating() {
    return axios.get(`${i18n.locale}/api/public/siteRating/getAverageRating`)
  },
  // список рейтинга
  getSiteRatingList(params) {
    let param = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    return axios.get(`${i18n.locale}/api/siteRating/getSiteRatingList?${param}`)
  },
}
